import { Routes } from "@angular/router";;
import { CardComponent } from "src/app/payment/card/card.component";
import { SelectcardComponent } from "src/app/payment/selectcard/selectcard.component";

export const PAYMENTS_ROUTES: Routes = [
    {
        path: 'payments/card', component: CardComponent
    },
    {
        path: 'payments/card/select', component: SelectcardComponent
    }
]